// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import LeftOutlinedSvg from "@ant-design/icons-svg/lib/asn/LeftOutlined";
import AntdIcon from "../components/AntdIcon";
const LeftOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: LeftOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    LeftOutlined.displayName = "LeftOutlined";
}
export default /*#__PURE__*/ React.forwardRef(LeftOutlined);
